module.exports = __webpack_public_path__ + "static/img/048江城政协app.4871edc.png";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/048江城政协app.png
// module id = 2oRu
// module chunks = 0